// extracted by mini-css-extract-plugin
export var active = "MobileSlider-module--active--6e8d4";
export var fadeInAnimation = "MobileSlider-module--fadeInAnimation--0960c";
export var pagination = "MobileSlider-module--pagination--5798b";
export var paginationButton = "MobileSlider-module--paginationButton--d4bcf";
export var scrollWrap = "MobileSlider-module--scrollWrap--518d2";